import {lazy} from 'react';

import {SEOProps, RouteConfig} from './declarations';

import {SITE_CONFIG} from './site.config';

/* -------------------- Lazy Loaded Pages -------------------- */
const Landing = lazy(() => import('./Pages/Landing'));
const Digital = lazy(() => import('./Pages/Digital/Digital'));
const Print = lazy(() => import('./Pages/Print/Print'));
const Imprint = lazy(() => import('./Pages/Imprint'));
const Privacy = lazy(() => import('./Pages/Privacy'));
const NotFound = lazy(() => import('./Pages/NotFound'));

export const ROUTES: RouteConfig[] = [
    {
        path: '/',
        seo: {
            title: 'Home',
            description: SITE_CONFIG.seo.defaultDescription,
            keywords: SITE_CONFIG.seo.keywords,
        },
        element: Landing,
    },
    {
        path: '/digital',
        seo: {
            title: 'Digital Services',
            description:
                'Dark mode optimized Zendesk apps and custom development solutions.',
            keywords: ['Zendesk', 'Apps', 'Digital Services'],
        },
        element: Digital,
    },
    {
        path: '/print',
        seo: {
            title: 'Print Products',
            description:
                'Bright, beautiful prints designed with care and creativity.',
            keywords: ['Prints', 'Posters', 'Calendars', 'Design'],
        },
        element: Print,
    },
    {
        path: '/imprint',
        seo: {
            title: 'Imprint',
            description: `Legal information for ${SITE_CONFIG.legal.company}`,
            noIndex: true,
        },
        element: Imprint,
    },
    {
        path: '/privacy',
        seo: {
            title: 'Privacy Policy',
            description: 'How we protect and handle your data',
            noIndex: true,
        },
        element: Privacy,
    },
];

export const NOT_FOUND_SEO: SEOProps = {
    title: '404 Not Found',
    description: 'Page not found',
    noIndex: true,
};

export const NotFoundPage = NotFound;
